import { useTranslation } from "react-i18next";

const monthDiff = (d1: Date | undefined, d2: Date | undefined) => {
    let months: number = 0;
    if(d1 !== undefined && d2 !== undefined) {
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth();
        months += d2.getMonth();
    }
    return months <= 0 ? 0 : months;
}

const Months = (d1: Date | undefined, d2: Date | undefined) => {
    const months = [];
    const [t, i18n] = useTranslation();
    if(d1 !== undefined && d2 !== undefined) {
       const diff = monthDiff(d1, d2);
       let current = d1.getMonth();
       for(let i = 0; i < diff; i++) {
          if(i > 0) current += 1;
          months.push(fullMonth[i18n.language][current]);
       }
    }
    return months
}

const fullMonth: { [key: string]: { [key: string]: string } } = {
    fr: {
        "1": "Janvier",
        "2": "Février",
        "3": "Mars",
        "4": "Avril",
        "5": "Mai",
        "6": "Juin",
        "7": "Juillet",
        "8": "Août",
        "9": "Septembre",
        "10": "Octobre",
        "11": "Novembre",
        "12": "Decembre",
    },
    en: {
        "1": "January",
        "2": "February",
        "3": "March",
        "4": "April",
        "5": "May",
        "6": "June",
        "7": "July",
        "8": "August",
        "9": "September",
        "10": "October",
        "11": "November",
        "12": "December",
    }
}

const findById = (index: string) => {
    return getAllAxes().filter(axe => axe.id === index)[0];
}

const getAllAxes = () => {
    return [
        { 
          id: "1",
          label: "Autisme",
          description: "Nous agissons pour aider les personnes en difficulté et agir contre toute forme d'exclusion.",
          sections: [
            { id: "1",
              label: "Nom du projet",
              description: "" 
            },
            { id: "2",
              label: "Contact opérationnel",
              description: "" 
            },
            { id: "3",
              label: "Structure Gestionnaire",
              description: "" 
            },
            { id: "4",
              label: "Signature de la convention",
              description: "" 
            },
            { id: "5",
              label: "Contact administratif",
              description: "" 
            },
            { id: "6",
              label: "Descriptif du projet",
              description: "" 
            },
            { id: "7",
              label: "Détails du compte bancaire utilisé par votre structure",
              description: "" 
            },
            { id: "8",
              label: "Documents à joindre",
              description: "" 
            },
            { id: "9",
              label: "Récapitulatif",
              description: "" 
            }
          ]
        },
        { 
          id: "2",
          label: "Culture",
          description: "Pour cet appel à projets, la fondation Orange soutient ainsi un projet constitué.",
          sections: [
            { id: "1",
              label: "Nom du projet",
              description: "" 
            },
            { id: "2",
              label: "Contact opérationnel",
              description: "" 
            },
            { id: "3",
              label: "Structure Gestionnaire",
              description: "" 
            },
            { id: "4",
              label: "Signature de la convention",
              description: "" 
            },
            { id: "5",
              label: "Contact administratif",
              description: "" 
            },
            { id: "6",
              label: "Descriptif du projet",
              description: "" 
            },
            { id: "7",
              label: "Détails du compte bancaire utilisé par votre structure",
              description: "" 
            },
            { id: "8",
              label: "Documents à joindre",
              description: "" 
            },
            { id: "9",
              label: "Récapitulatif",
              description: "" 
            }
          ]
        },
        { 
          id: "3",
          label: "Ecoles Numériques",
          description: "Cet appel à projets a pour objectif de renforcer le programme 'Ecoles Numériques' dans les zones rurales enclavées ou en zone péri-urbaine pour les écoles les plus défavorisées et/ou démunies d'ouvrages scolaires.",
          sections: [
            { id: "1",
              label: "Nom du projet",
              description: "" 
            },
            { id: "2",
              label: "Contact opérationnel",
              description: "" 
            },
            { id: "3",
              label: "Structure Gestionnaire",
              description: "" 
            },
            { id: "4",
              label: "Signature de la convention",
              description: "" 
            },
            { id: "5",
              label: "Contact administratif",
              description: "" 
            },
            { id: "6",
              label: "Descriptif du projet",
              description: "" 
            },
            { id: "7",
              label: "Détails du compte bancaire utilisé par votre structure",
              description: "" 
            },
            { id: "8",
              label: "Documents à joindre",
              description: "" 
            },
            { id: "9",
              label: "Récapitulatif",
              description: "" 
            }
          ]
        },
        { 
          id: "4",
          label: "Fablabs Solidaires",
          description: "l'appel à projets FabLab vise à former les jeunes en insertion en leur offrant un cursus ou des formations en fabrication numérique valorisant leurs compétences.",
          sections: [
            { id: "1",
              label: "Nom du projet",
              description: "" 
            },
            { id: "2",
              label: "Contact opérationnel",
              description: "" 
            },
            { id: "3",
              label: "Structure Gestionnaire",
              description: "" 
            },
            { id: "4",
              label: "Signature de la convention",
              description: "" 
            },
            { id: "5",
              label: "Contact administratif",
              description: "" 
            },
            { id: "6",
              label: "Descriptif du projet",
              description: "" 
            },
            { id: "7",
              label: "Détails du compte bancaire utilisé par votre structure",
              description: "" 
            },
            { id: "8",
              label: "Documents à joindre",
              description: "" 
            },
            { id: "9",
              label: "Récapitulatif",
              description: "" 
            }
          ]
        }
      ];
};

const getStatusLibelle = (status: string) => {
  let statusLabel = '';
  
  switch(status) {
      case 'Draft': {
          statusLabel = 'Brouillon';
          break;
      }
      case 'Created': {
          statusLabel = 'Crée';
          break;
      }
      case 'Submitted': {
          statusLabel = 'Soumis';
          break;
      }
      case 'Preselected': {
          statusLabel = 'Préselectionné';
          break;
      }
      case 'Validated': {
          statusLabel = 'Validé';
          break;
      }
      case 'NotValidated': {
          statusLabel = 'Non Validé';
          break;
      }
      case 'Clotured': {
          statusLabel = 'Cloturé';
          break;
      }
      default: {
          statusLabel = '';
          break;
      }
  }

  return statusLabel;
};

const getStatusByLang = (status: string, lang: string) => {
  let statusLabel = '';
  
  switch(status) {
      case 'Draft': {
          statusLabel = lang === 'fr' ? 'Brouillon' : 'Draft';
          break;
      }
      case 'Created': {
          statusLabel = lang === 'fr' ? 'Crée' : 'Create';
          break;
      }
      case 'Submitted': {
          statusLabel = lang === 'fr' ? 'Soumis' : 'Submit';
          break;
      }
      case 'Preselected': {
          statusLabel = lang === 'fr' ? 'Préselectionné' : 'Preselect';
          break;
      }
      case 'Validated': {
          statusLabel = lang === 'fr' ? 'Validé' : 'Validate';
          break;
      }
      case 'NotValidated': {
          statusLabel = lang === 'fr' ? 'Non Validé' : 'Not Validate';
          break;
      }
      case 'Clotured': {
          statusLabel = lang === 'fr' ? 'Cloturé' : 'Close';
          break;
      }
      default: {
          statusLabel = '';
          break;
      }
  }

  return statusLabel;
};

const getStatusColor = (status: string) => {
  let statusColor = '';
  
  switch(status) {
      case 'Draft': {
          statusColor = 'badge-warning';
          break;
      }
      case 'Created': {
          statusColor = 'badge-secondary';
          break;
      }
      case 'Submitted': {
          statusColor = 'badge-primary';
          break;
      }
      case 'Preselected': {
          statusColor = 'badge-success';
          break;
      }
      case 'Validated': {
          statusColor = 'badge-info';
          break;
      }
      case 'NotValidated': {
          statusColor = 'badge-danger';
          break;
      }
      case 'Clotured': {
          statusColor = 'badge-dark';
          break;
      }
      default: {
          statusColor = '';
          break;
      }
  }

  return statusColor;
};


const truncateText = (text: string, limit: number) => {
  if (text.length > limit) {
      for (let i = limit; i > 0; i--) {
          if(text.charAt(i) === ' ' && (text.charAt(i-1) !== ','||text.charAt(i-1) !== '.'||text.charAt(i-1) !== ';')) {
              return text.substring(0, i) + '...';
          }
      }
      return text.substring(0, limit) + '...';
  } else {
      return text;
  }
};


export { monthDiff, Months, findById, getAllAxes, getStatusLibelle, getStatusColor, getStatusByLang, truncateText };